module.exports = __webpack_public_path__ + "media/11.b862ddbf.wav";